package dev.wyns.ventrova.platform

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.rememberUpdatedState
import kotlinx.browser.window

/**
 * Maps open sheets and pages to browser history entries, so the browser's back button (or the
 * Android back gesture in a mobile browser) closes them instead of leaving the site.
 */
class BrowserBackNavigation : BackNavigation {
    private class Entry(val onBack: () -> Unit)

    private val stack = mutableListOf<Entry>()

    /** Pops caused by our own history.back() calls, which must not trigger a handler. */
    private var ignoredPops = 0

    init {
        window.addEventListener("popstate", {
            if (ignoredPops > 0) {
                ignoredPops--
            } else {
                stack.removeLastOrNull()?.onBack?.invoke()
            }
        })
    }

    @Composable
    override fun BackHandler(enabled: Boolean, onBack: () -> Unit) {
        val currentOnBack by rememberUpdatedState(onBack)
        DisposableEffect(enabled) {
            if (!enabled) return@DisposableEffect onDispose {}
            val entry = Entry { currentOnBack() }
            stack += entry
            window.history.pushState(null, "", window.location.href)
            onDispose {
                // Closed from the UI instead of the back button: drop the history entry we added.
                if (stack.remove(entry)) {
                    ignoredPops++
                    window.history.back()
                }
            }
        }
    }
}
